import React from "react";
import styles from "./NormGroup.less";

function NormGroup({ number, name }) {
  return (
    <div className={styles.root}>
      <div className="normNumber">
        <span>指标编号: </span>
        {number}
      </div>
      <div className="normName">
        <span>指标名称: </span>
        {name}
      </div>
    </div>
  );
}

export default NormGroup;
